import { Model } from './Model';

export class PublisherSearch extends Model {
  public apiPath = 'support/publishers/search';
  public className = 'publisherSearchSummaries';
  public publisherId: number;
  public publisherName?: string;
}